module.exports = __webpack_public_path__ + "static/media/Picture1.958a2b4c.jpg";